import React, { FC, useCallback, useState } from 'react';
import { Setting, Settings } from '../../scripts/settings';
import { _settingsUpdater } from '../context/settings/SettingsLoader';

import './SettingsPage.scss';
import SettingsPicker from './settingsPicker/SettingsPicker';

const SettingsPage: FC = () => {


    const [settings, setSettings] = useState<Setting[]>(Settings.getSettings())

    const updateSetting = useCallback((newSetting: Setting) => {
        const newSettings = [...settings];
        const matches: number[] = [];
        settings.forEach((setting, idx) => {
            if (setting._name === newSetting._name) {
                matches.push(idx)
            }
        })
        if (matches.length === 1) {
            newSettings[matches[0]] = newSetting;
            Settings.saveSettings(newSettings);
            setSettings(newSettings)
            _settingsUpdater.update(); // This causes the settings context to know there's an update
        }
    }, [settings])

    return <div className='Page SettingsPage'>
        <div className="header serif">
            Settings
        </div>
        {
            settings.map((setting, idx) => (
                <SettingsPicker setting={setting} update={updateSetting} key={idx} />
            ))
        }
    </div>
}

export default SettingsPage;